import React from "react";

import IdleTimeCellContent from "../components/IdleTimeCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function idleTime({ width, onResize }: Column.Options) {
	return base(
		ColumnId.IdleTime,
		(item) => <IdleTimeCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default idleTime;
